import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { CustomerShell } from "../customer/CustomerShell";

export function CustomerProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-primary" data-testid="customer-auth-loading">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-accent border-t-transparent" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/customer/login" state={{ from: location }} replace />;
  }

  if (user.role !== "customer") {
    return <Navigate to="/" replace />;
  }

  // A customer flagged for a forced password change cannot reach any dashboard
  // page — not even via a direct URL or an existing session — until they set one.
  if (user.must_change_password) {
    return <Navigate to="/customer/set-password" replace />;
  }

  return <CustomerShell>{children}</CustomerShell>;
}
